/**
 * Modal Molecule
 *
 * Modal reutilizável
 */
import React, { useEffect } from 'react'
import { X } from 'lucide-react'
import Button from '../atoms/Button'

function Modal({
	isOpen,
	onClose,
	title,
	children,
	footer,
	size = 'md',
	closeOnOverlay = true,
}) {
	// Fechar com ESC
	useEffect(() => {
		const handleEsc = (e) => {
			if (e.key === 'Escape') onClose()
		}

		if (isOpen) {
			document.addEventListener('keydown', handleEsc)
			document.body.style.overflow = 'hidden'
		}

		return () => {
			document.removeEventListener('keydown', handleEsc)
			document.body.style.overflow = ''
		}
	}, [isOpen, onClose])

	if (!isOpen) return null

	const sizes = {
		sm: 'max-w-md',
		md: 'max-w-lg',
		lg: 'max-w-2xl',
		xl: 'max-w-4xl',
		full: 'max-w-[90vw]',
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			{/* Overlay */}
			<div
				className="absolute inset-0 bg-black/50"
				onClick={closeOnOverlay ? onClose : undefined}
			/>

			{/* Modal */}
			<div className={`relative bg-base-300 rounded-xl shadow-xl w-full ${sizes[size]} max-h-[90vh] flex flex-col`}>
				{/* Header */}
				<div className="flex items-center justify-between px-6 py-4 border-b border-base-200">
					<h2 className="text-lg font-semibold text-text">{title}</h2>
					<button
						onClick={onClose}
						className="p-2 hover:bg-base-400 rounded-lg transition-colors"
					>
						<X className="w-5 h-5 text-text-body" />
					</button>
				</div>

				{/* Content */}
				<div className="flex-1 overflow-y-auto px-6 py-4">
					{children}
				</div>

				{/* Footer */}
				{footer && (
					<div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-base-200">
						{footer}
					</div>
				)}
			</div>
		</div>
	)
}

// Preset de confirmação
export function ConfirmModal({
	isOpen,
	onClose,
	onConfirm,
	title = 'Confirmar ação',
	message,
	confirmLabel = 'Confirmar',
	cancelLabel = 'Cancelar',
	variant = 'danger',
	loading = false,
}) {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			size="sm"
			footer={
				<>
					<Button variant="ghost" onClick={onClose} disabled={loading}>
						{cancelLabel}
					</Button>
					<Button
						variant={variant}
						onClick={onConfirm}
						loading={loading}
					>
						{confirmLabel}
					</Button>
				</>
			}
		>
			<p className="text-text-body">{message}</p>
		</Modal>
	)
}

export { Modal }
export default Modal
